export const FONTS = {
  heading: "'Duru Sans', sans-serif",
  // body: "'Inter', sans-serif",
  body: "'Duru Sans', sans-serif",
  mono: "'Inter', sans-serif",
  // maaxMono: "'Maax Mono', sans-serif",
  //crimsonText: "'Crimson Text', sans-serif",
  mikado: "'Mikado', sans-serif",
  spectral: "'Spectral', serif",
  duruSans: "'Duru Sans', sans-serif",
}
